import { FC } from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import QRCode from 'qrcode.react';
import Button, { ButtonType } from '../Button/Button';

import styles from './QRModal.module.scss';
import ReactiveText from '../ReactiveText/ReactiveText';

const messages = defineMessages({
	x_QRCode: {
		id: 'payments.x_QRCode',
		defaultMessage: '{Label} QR code',
	},
	close: {
		id: 'base.close',
		defaultMessage: 'Close',
	},
});

type Props = {
	label: string;
	rawData: string;
	displayData: string;
	onClose: () => void;
};

const QRModal: FC<Props> = ({ rawData, displayData, label, onClose }) => {
	const { formatMessage } = useIntl();

	return (
		<div className={styles.container}>
			<div className={styles.closeIcon} onClick={() => onClose()} />
			<div className={styles.body}>
				<h2 className={styles.title}>
					{formatMessage(messages.x_QRCode, { Label: label })}
				</h2>
				<QRCode size={132} value={rawData} />
				<div className={styles.labeled}>
					<label>{label}</label>
					<ReactiveText minSize={1} maxSize={16}>
						{displayData}
					</ReactiveText>
				</div>
				<Button className={styles.button} type={ButtonType.BUTTON} onClick={onClose}>
					<FormattedMessage {...messages.close} />
				</Button>
			</div>
		</div>
	);
};

export default QRModal;
